import Vue from "vue";
import { setPicSize } from "./utils/pic-util.js";
import { bindAriaEvent } from "./utils/bindAria.js";
import { loginBtnIndex as HeadLogin, loginIndex } from 'pc-login'

var $ = require('jquery');
import '@/utils/eventBus'
import  { MptcfePalyer }  from 'mptcfe-pc-player'
import HotList from '@/pages/article_video/comps/hot-list.vue'
import Share from './vuecomps/shareVideo.vue'
import { renderRightBtns } from '@/pages/article_main/js/handleDom'
import SideComment, { eventEmitter, eventNameMap } from "common-components/lib/sideComment/index"
import "common-components/lib/sideComment/index.css"
import { getUserInfo } from "./request/request";
import RecommendList from "@/pages/article_video/comps/recommend-list.vue";
import TextOverflowUnfolding from '@/vuecomps/textOverflowUnfolding.vue'

const throttle = function(func, time) {
    var prev = 0
    return function() {
        var cur = Date.now()
        var context = this
        if(cur - prev > time) {
            func.apply(context)
            prev = cur
        }
    }
}

const initLogin = () => {
    loginIndex?.$el?.on('login:success', () => {
        window.EVENT_BUS.$emit('loginSuccess')
    })
}
/**
 * @description 初始化更多推荐
 * @param {*} opts
 * @returns
 */
const initRecMore = function(opts) {
    if(!window.videoIns) return ''
    var recMoreDom = document.querySelector('#recMore')
    var playerDom = document.getElementById('sohuplayer');
    var recList = document.getElementById('recMore-recList');
    var replayDom = document.getElementById('replay')
    var recItemWidth, recItemHeight, recContainerWidth, recContainerHeight, space
    var isFullScreen = false
    var playerState = 'play', endState = 'ended', loadRecListState = 'setRecList', replayState = 'PLAY_REPEAT_ACTION', fullScreenState = 'fullscreen', exitFullScreenState = 'exitfullscreen'
    // 初始化尺寸的的函数,依据video标签尺寸判断推荐数据的宽高
    var initDomSize = function() {
        var videoDom = document.querySelector('video');
        var videoWidth =  videoDom.offsetWidth
        var recMoreDomWidth
        var recMoreDomHeight

        //推荐内容宽高适配
        if(videoWidth > 1130) {
            recItemHeight = 128
            recItemWidth = 230
            space = 18
            recContainerHeight = recItemHeight * 2 + space * 1
            // 调整每个 item 大小
            recList.classList.remove('smallItem')
            recList.classList.add('bigItem')
        } else {
            recItemHeight = 100
            recItemWidth = 180
            space = 12
            recContainerHeight = recItemHeight * 2 + space * 1
            // 调整每个recItem代销
            recList.classList.add('smallItem')
            recList.classList.remove('bigItem')
        }

        // 播放器宽高适配
        if(isFullScreen) {
            recMoreDomWidth = '100%'
            recMoreDomHeight = 'calc(100% - 56px)'
            recMoreDom.style.width = recMoreDomWidth;
            recMoreDom.style.height = recMoreDomHeight;

            recContainerWidth = recItemWidth * 4 + space * 3
        } else {
            recMoreDomWidth = playerDom.offsetWidth;
            recMoreDomHeight = playerDom.offsetHeight - 56;
            recMoreDom.style.width = recMoreDomWidth + 'px';
            recMoreDom.style.height = recMoreDomHeight + 'px';

            recContainerWidth = recItemWidth * 3 + space * 2
        }

        recList.style.width = recContainerWidth + 'px'
        recList.style.height = recContainerHeight + 'px'
        recList.style.overflow = 'hidden'
    }
    // 设置推荐位个数
    const setRecListArr = function(list) {
        var slicelist = list
        var html = ''
        slicelist.forEach(function(item) {
            var cover = item.cover && item.cover[0]
            const ratio = 2
            const coverWidth = 180 * ratio
            const coverHeight = 100 * ratio
            cover = setPicSize(cover, coverWidth, coverHeight)
            html = html + "<a href=" + item.url +"><div class='recList-item'><img src=" + cover + " /><div class='brief'>" + item.title + "</div></div></a>"
        })
        recList.innerHTML = html
    }
    // 初始化状态
    window.videoIns.on(playerState, function() {
        recMoreDom.classList.remove('rec-flex')
        initDomSize()
        // 分享删除文字提示
        if (recMoreDom) {
            // 查找子元素
            const ttElement = recMoreDom.querySelector('.tt');
            if (ttElement) {
                // 设置元素的 HTML 内容为空
                ttElement.innerHTML = '';
            }
        }

        // 重播事件
        replayDom.addEventListener('click',()=>{
            recMoreDom.classList.remove('rec-flex')
            // 模拟点击
            var controlPlayBtn = document.querySelector('.control-play-btn');
            if (controlPlayBtn) {
                controlPlayBtn.click();
            }
            window.sohuSpm.sendAction({acode: 8904})
        })

        // 监听resize事件
        window.addEventListener('resize', function() {
            // 调用 throttle 函数并立即执行
            throttle(initDomSize, 300)();
        });

        // 监听点击其他dom元素的事件
        var recMoreClass = document.querySelector('.recMore');
        if (recMoreClass) {
            // 为元素添加点击事件监听器
            recMoreClass.addEventListener('click', function(e) {
                if (e.target.className.indexOf('recMore') > -1) {
                    recMoreDom.classList.remove('rec-flex')
                    var controlPlayBtn = document.querySelector('.control-play-btn');
                    if (controlPlayBtn) {
                        // 模拟点击
                        controlPlayBtn.click();
                    }
                }
            });
        }

    })
    // 结束时展示
    window.videoIns.on(endState, function() {
        recMoreDom.classList.add('rec-flex')
        sohuSpm.domDidChange({target:'end-author'})
        sohuSpm.domDidChange({target:'end-rec'})
        sohuSpm.domDidChange({target:'end-fx'})
    })
    // recList初始化
    window.videoIns.on(loadRecListState, function(list) {
        var endAuthor = document.querySelector('#end-author');
        if (endAuthor) {
            // 获取元素的 data-url 属性值
            var url = endAuthor.getAttribute('data-url');
            // 获取元素的文本内容
            var textContent = endAuthor.innerHTML;
            // 创建一个新的 a 元素
            var link = document.createElement('a');
            link.href = url;
            link.target = "_blank";
            link.innerHTML = textContent;
            // 清空原元素内容
            endAuthor.innerHTML = '';
            // 将新创建的 a 元素添加到原元素中
            endAuthor.appendChild(link);
        }


        setRecListArr(list)
    })
    // 全屏时
    window.videoIns.on(fullScreenState, function() {
        recMoreDom.classList.add('fullScreen-recMore')
        isFullScreen = true
        initDomSize(isFullScreen)
    })
    // 退出全屏时
    window.videoIns.on(exitFullScreenState, function() {
        recMoreDom.classList.remove('fullScreen-recMore')
        isFullScreen = false
        initDomSize(isFullScreen)
    })
}

export default function (opts) {
    window.pcArticleInfo = opts
    var videoIns = null
    var videoLevel =
        opts.videoInfo.videoLevel[1] ||
        opts.videoInfo.videoLevel[2] ||
        opts.videoInfo.videoLevel[3]
    videoIns = new MptcfePalyer({
        el: "sohuplayer",
        url: videoLevel?.url.replace(/^(https?:)?/, ""),
        poster: opts.videoInfo.cover,
        autoplay: true,
        spmParams: {
            spm:
                "smpc.vd-land.video.0." +
                (window.sohuSpm && window.sohuSpm.getCodes().e),
            clkParam:
                "newsId:" + opts.news_id + ";authorId:" + opts.media_id,
        },
        isHiddenReplayButton: true,
    })
    window.videoIns = videoIns
    initRecMore(opts)

    //登录条
    new HeadLogin({
        el: "#head-login",
        mark: "article-video",
        type: "other",
    })
    // 分享功能
    if(document.querySelector("#share") ){
        new Vue({
            el: "#share",
            components: {
                Share
            },
        })
    }

    // 初始化登录
    initLogin()

    // 评论功能
    if(document.querySelector("#videoComment")){
        new Vue({
            el: "#videoComment",
            template: '<SideComment :isLogin="isLogin" :userInfo="userInfo" :articleId="articleId" :accountId="accountId" :articleTitle="articleTitle"></SideComment>',
            components: {
                SideComment,
            },
            data: {
                isLogin: false,
                userInfo: undefined,
                articleId: opts.news_id,
                accountId: opts.media_id,
                articleTitle: opts.title,
            },
            methods: {
                initEvent(){
                    eventEmitter.on(eventNameMap.waitPcLogin, (callback) => {
                        window.EVENT_BUS.$on('loginSuccess', () => {
                            callback && callback()
                        })
                        loginIndex?.login()
                    })
                    window.EVENT_BUS.$on('loginSuccess', () => {
                        this.getUserInfo()
                    })
                },
                async getUserInfo(){
                    try {
                        const res = await getUserInfo()
                        if (res?.code == 1 && res?.data) {
                            this.isLogin = true
                            this.userInfo = res?.data
                        }
                    } catch (error) {
                        console.log('获取用户信息失败', error)
                    }
                }
            },
            mounted(){
                this.initEvent()
                this.getUserInfo()
            }
        })
    }

    if(document.querySelector('#videoRecListContent') ){
        new Vue({
            el: "#videoRecListContent",
            template: '<RecommendList></RecommendList>',
            components: {
                RecommendList
            },
        })
    }

    if(document.querySelector('#videoBrief')){
        new Vue({
            el: "#videoBrief",
            template: '<TextOverflowUnfolding :text="text"></TextOverflowUnfolding>',
            components:{
                TextOverflowUnfolding
            },
            data: {
                text: opts.brief,
            }
        })
    }

    if(document.querySelector("#videoHotListContent") ){
        new Vue({
            el: "#videoHotListContent",
            components: {
                HotList
            },
        })
    }

    // 处理无障碍，关怀版点击绑定
    bindAriaEvent()

    // 右侧悬浮按钮
    renderRightBtns()

    if(window.sohuSpm && typeof window.sohuSpm.domDidChange === 'function') {
        window.sohuSpm.domDidChange({target: 'info'});
    }
}